export default __webpack_public_path__ + "static/media/Belt of the Unutterable.b5ad4420.jpg";